export default __webpack_public_path__ + "static/media/product-design-guild-background.caff01b3.png";